
import { Fragment } from 'react'

import ToolsPanel from "../components/ToolsPanel";

import Content from '../components/Content';
import { InspectorSelector } from '../components/Inspector/inspectorSelector';
import { LoadingPage } from './LoadingPage';
import { StepByStepHelp } from '../components/Content/stepByStepHelp';
import { ConfirmDeleteModal } from '../components/Commun/confirmDeleteModal';
import { useFloorPlanMapData } from '../hooks/useFloorPlanMapData';
import { DemoIframe } from './DemoIframe';
import { useAppSelector } from '../hooks';


export default function Editor() {
    const { loadingPr, loadingText } = useFloorPlanMapData()
    const showDemo = useAppSelector(s => s.editor.showDemo)

    return (
        <Fragment>
            <StepByStepHelp />
            <ConfirmDeleteModal />
            <div className='tools-panel'>
                <ToolsPanel />
            </div>
            <Content />
            <InspectorSelector />
            <LoadingPage loadingPr={loadingPr} text={loadingText} displayNone={loadingPr === 100} />
            {showDemo && <DemoIframe />}
        </Fragment>
    )
}